// Export any functions in here to be used as a helper/operator/appliable function

export function randomInt(min, max) {
   return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function slugify(string) {
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "") //  /[^\w\-]+/g
    .replace(/--+/g, "-") //  /\-\-+/g
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}



// WEBPACK FOOTER //
// ./src/helpers.js